/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { ImportRowErrorStatus } from './ImportRowErrorStatus';
import {
    ImportRowErrorStatusFromJSON,
    ImportRowErrorStatusFromJSONTyped,
    ImportRowErrorStatusToJSON,
    ImportRowErrorStatusToJSONTyped,
} from './ImportRowErrorStatus';

/**
 * 
 * @export
 * @interface ImportRowError
 */
export interface ImportRowError {
    /**
     * 
     * @type {string}
     * @memberof ImportRowError
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRowError
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ImportRowError
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportRowError
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportRowError
     */
    importSessionId: string;
    /**
     * 
     * @type {ImportSession}
     * @memberof ImportRowError
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {number}
     * @memberof ImportRowError
     */
    rowIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportRowError
     */
    rawRowDataJson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportRowError
     */
    errorsJson?: string | null;
    /**
     * 
     * @type {ImportRowErrorStatus}
     * @memberof ImportRowError
     */
    status?: ImportRowErrorStatus;
    /**
     * 
     * @type {string}
     * @memberof ImportRowError
     */
    correctedRowDataJson?: string | null;
}



/**
 * Check if a given object implements the ImportRowError interface.
 */
export function instanceOfImportRowError(value: object): value is ImportRowError {
    if (!('importSessionId' in value) || value['importSessionId'] === undefined) return false;
    return true;
}

export function ImportRowErrorFromJSON(json: any): ImportRowError {
    return ImportRowErrorFromJSONTyped(json, false);
}

export function ImportRowErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportRowError {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'importSessionId': json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'rawRowDataJson': json['rawRowDataJson'] == null ? undefined : json['rawRowDataJson'],
        'errorsJson': json['errorsJson'] == null ? undefined : json['errorsJson'],
        'status': json['status'] == null ? undefined : ImportRowErrorStatusFromJSON(json['status']),
        'correctedRowDataJson': json['correctedRowDataJson'] == null ? undefined : json['correctedRowDataJson'],
    };
}

export function ImportRowErrorToJSON(json: any): ImportRowError {
    return ImportRowErrorToJSONTyped(json, false);
}

export function ImportRowErrorToJSONTyped(value?: ImportRowError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'rowIndex': value['rowIndex'],
        'rawRowDataJson': value['rawRowDataJson'],
        'errorsJson': value['errorsJson'],
        'status': ImportRowErrorStatusToJSON(value['status']),
        'correctedRowDataJson': value['correctedRowDataJson'],
    };
}

